import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ProductsAndPagesBrandingIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M16.503 7.495c5.15 0 7.497 1.554 7.497 2.998v10.492c0 1.444-2.347 2.998-7.5 2.998-.196.011-.417.017-.635.017-1.958 0-3.926-.453-5.692-1.31-.373-.18-.528-.628-.347-1 .18-.373.63-.529 1.002-.348 1.753.846 3.69 1.24 5.634 1.143 4.162 0 6.038-1.15 6.038-1.5v-8.604c-1.576.81-4.051 1.11-6 1.11h-.068c-1.022-.001-2.042-.082-3.051-.243-.408-.067-.686-.45-.622-.859.03-.197.139-.373.3-.49.162-.117.364-.164.561-.131.952.15 1.915.225 2.879.224 4.13 0 6.001-1.15 6.001-1.5 0-.348-1.87-1.498-6-1.498h-.048c-.952 0-1.905.076-2.833.224-.196.033-.398-.014-.559-.13-.161-.117-.27-.294-.3-.49-.065-.409.213-.793.621-.86 1.006-.161 2.022-.243 3.041-.243h.081zM10.5 0c.827 0 1.5.673 1.5 1.499v7.495c0 2.135-1.144 4.107-3 5.166v3.827c0 1.654-1.346 2.998-3 2.998s-3-1.345-3-2.998V14.16c-1.856-1.059-3-3.03-3-5.165V1.499C0 .673.673 0 1.5 0h9zm0 8.994h-9c.007 1.726 1.006 3.296 2.569 4.033.262.123.431.39.431.678v4.282c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5v-4.282c0-.289.169-.555.431-.678 1.562-.738 2.562-2.307 2.569-4.033zM3 1.499H1.5v5.996h9V1.499H9v2.248c0 .414-.336.75-.75.75s-.75-.336-.75-.75V1.5h-3v2.248c0 .414-.336.75-.75.75S3 4.16 3 3.747V1.5z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ProductsAndPagesBrandingIcon = __decorateClass([
  customElement("elm-products-and-pages-branding-icon")
], ProductsAndPagesBrandingIcon);
export { ProductsAndPagesBrandingIcon };
